import { useAction, useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import {
  openBuyBoostersFlowEvent,
  openBuyPremiumFlowEvent,
} from '@root/entities/premium'
import {
  CheckCurrencyActions,
  CheckCurrencyActive,
  CheckCurrencyFailed,
  CheckCurrencyPassed,
} from '@root/features/premium'
import { useOptionalAtom } from '@root/shared/lib'
import { Separator as Separator_ } from '@root/shared/ui-kit'

import type {
  CheckCurrencyReatom,
  CurrencySafetyCheck,
} from '@root/features/premium'

type Props = {
  model: CheckCurrencyReatom
  result: CurrencySafetyCheck
}

export const CurrencyCheckResult: React.FC<Props> = ({ model, result }) => {
  const [checkCurrencyState] = useAtom(model.checkCurrencyStateAtom)
  const openBuyBoostersFlow = useAction(openBuyBoostersFlowEvent)
  const openBuyPremiumFlow = useAction(openBuyPremiumFlowEvent)
  const premium = useOptionalAtom(result.premiumInfo?.premium)

  const handleBuyBoosters = () => {
    if (checkCurrencyState.value && checkCurrencyState.value.premiumInfo) {
      openBuyBoostersFlow({
        currency: checkCurrencyState.value.currency,
        premium: checkCurrencyState.value.premiumInfo,
        shouldCheckSafety: false,
      })
    }
  }
  const handleBuyPremium = () => {
    if (checkCurrencyState.value) {
      openBuyPremiumFlow({
        currency: checkCurrencyState.value.currency,
        premium: checkCurrencyState.value.premiumInfo,
        shouldCheckSafety: false,
      })
    }
  }

  const renderResult = () => {
    if (premium) {
      return <CheckCurrencyActive result={result} />
    }
    if (result.hasPassedSecurityChecks) {
      return <CheckCurrencyPassed result={result} />
    }

    return (
      <CheckCurrencyFailed withRetry={false} result={result} model={model} />
    )
  }

  return (
    <Root>
      {renderResult()}
      <Separator />
      <CheckCurrencyActions
        onBuyBoosters={handleBuyBoosters}
        onBuySubscription={handleBuyPremium}
        result={result}
      />
    </Root>
  )
}

const Root = styled.div`
  padding: 22px 16px 40px;
  place-self: center;
`

const Separator = styled(Separator_)`
  margin: 16px 0;
`
